// eslint-disable-next-line import/prefer-default-export
export const formulaCategory = {
  'general': 0,
  'drop': 1
}
